(function($) {

    var header = $('header'),
        headerHeight = header.outerHeight();

    function onScroll() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop >= headerHeight) {
            header.addClass('scrolled');
        }
        else {
            header.removeClass('scrolled');
        }
    }

    $(window).on('load', function() {
        if (!header.hasClass('no-js')) {
            onScroll();
        }
    });

    $(window).on('scroll', function () {
        if (!header.hasClass('no-js')) {
            onScroll();
        }
    });

    $(window).on('resize', function() {
        headerHeight = header.outerHeight();
    });

    header.find('.hamburger').on('click', function() {
        $(this).toggleClass('is-active');
        $('body').toggleClass('overflow-hidden');
        header.toggleClass('mobile-menu-open');3
        header.find('.mobile-menu').toggleClass('is-active');
    });

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

})( jQuery );